/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutlineSharp";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { InputAdornment, makeStyles } from "@material-ui/core";
import { GetStatusResponse } from "../../models/basicInformation.model";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { prefixer, WEBKIT } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { style } from "@mui/system";
import { red } from "@mui/material/colors";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface MultiSelectCmpPropsType {
  options?: any[];
  onChange?: any;
  label?: string;
  value?: any;
  name?: string;
  id?: string;
  changeMultiSelect?: any;
  responseValue?: GetStatusResponse[];
  onBlur?: any;
  onSelect?: any;
  autocompleteKey?: any;
  defaultValue?: any;
  disable?: any;
}
let mainColor: any;

const useStyles = makeStyles((theme) => ({
  "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
    color: "red !important",
    backgroundColor: "red !important",
  },
  root: {
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap  !important",
      color: "#333",
      position: "initial",
      margin: "3px 0",
      paddingRight: "5px !important",
    },
    "& .MuiChip-label": {
      overflow: "inherit !important",
    },
    "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
      color: "#12354 !important",
      backgroundColor: "red !important",
    },
    // "& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
    //     left: "32px !important", // probably the width of your search IconButton or more if needed
    // },
  },
  inputRoot: {
    overflow: "inherit !important",
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      // maxWidth: '200px  !important',
      whiteSpace: "nowrap  !important",
      color: "#333",
    },
    "&.Mui-focused fieldset": {
      // borderColor: "#C52328 !important",
      // borderColor: "green !important",
      borderWidth: "2px !important",
      position: "absolout !important",
    },
    "& .muirtl-11j1b2e-MuiInputBase-root-MuiOutlinedInput-root": {
      color: "red !important",
      backgroundColor: "red !important",
    },
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: "#1565C0",
    },

    "&:hover": {
      backgroundColor: "#1565C0",
    },
    backgroundColor: "#fff",
  },
}));

export default function AutoCompleteSearch(props: MultiSelectCmpPropsType) {
  const [val, setVal] = useState<any>(
    props.options?.length ? props.options[0] : null
  );
  const classes = useStyles();

  useEffect(() => {
    if (props.value && props.options?.length) {
      const defaultVal = props.options.find(
        (option) => option.id === props.value
      );
      setVal(defaultVal || null);
      if (defaultVal) {
        props.onChange(defaultVal.id, defaultVal.title);
      }
    } else if (props.options?.length === 1) {
      const defaultVal = props.options[0];
      setVal(defaultVal);
      props.onChange(defaultVal.id, defaultVal.title);
    }
  }, [props.options, props.value]);

  const handleChange = (event: object, value: any) => {
    setVal(value);
    props.onChange(value?.id, value?.title);
  };

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl" className="autoCompleteSearch-container">
          <Autocomplete
            disabled={props.disable}
            key={props.autocompleteKey}
            onBlur={props.onBlur}
            onSelect={props.onSelect}
            style={{ position: "inherit", direction: "rtl" }}
            popupIcon={<KeyboardArrowDownIcon />}
            ChipProps={{ deleteIcon: <></> }}
            classes={classes}
            limitTags={1}
            id="multiple-limit-tags"
            filterSelectedOptions={false}
            options={props.options!}
            onChange={handleChange}
            defaultValue={props.options?.length ? props.options[0] : null}
            getOptionLabel={(option) => option.title}
            value={val}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.label}
                classes={classes}
                className="autoCompleteSearchField"
              />
            )}
            disableClearable={false}
          />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
